module.exports = __webpack_public_path__ + "media/images/icons/filter-menu-closed-6f54d8cba6ebbe118a363fbc447b2118.svg";